import { Award } from "lucide-react";
import { TRUST } from "@/data/content";
import { Reveal } from "@/components/site/Reveal";

export const TrustStrip = () => (
  <section data-testid="trust-strip" className="border-b border-slate-200 bg-white py-14">
    <div className="container-x">
      <Reveal className="grid items-center gap-8 lg:grid-cols-12">
        <p className="eyebrow text-slate-500 lg:col-span-3">Why businesses choose us</p>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:col-span-9 lg:grid-cols-6">
          {TRUST.map((t) => (
            <div key={t} className="group flex items-center justify-center gap-2 rounded-xl border border-slate-200 px-3 py-4 text-sm font-semibold text-slate-500 transition-colors duration-300 hover:border-[#1777AF]/40 hover:text-slate-900">
              <Award className="h-4 w-4 text-slate-400 transition-colors group-hover:text-[#1777AF]" /> {t}
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);
